import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { useQuery } from '@tanstack/react-query';
import api from 'utils/api';
import getPictureUrl from 'utils/image/getPictureUrl';
import { browseTopicsQueryKey } from './queryKeys';
function withThumbnails(items) {
  return items.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      pictureUrl: getPictureUrl({
        id: item.thumbnailId
      })
    });
  });
}
export default function useFetchBrowseTopics() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    topicId = _ref.topicId,
    enabled = _ref.enabled;
  function fetchTopics() {
    return _fetchTopics.apply(this, arguments);
  }
  function _fetchTopics() {
    _fetchTopics = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$api, topic, _yield$api$subtopics, subtopics, data;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return api('get', '/api/me/filters', {
              topic: topicId
            });
          case 1:
            _yield$api = _context.sent;
            topic = _yield$api.topic;
            _yield$api$subtopics = _yield$api.subtopics;
            subtopics = _yield$api$subtopics === void 0 ? [] : _yield$api$subtopics;
            data = {
              topic: topic,
              subtopics: withThumbnails(subtopics)
            };
            return _context.abrupt("return", data);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _fetchTopics.apply(this, arguments);
  }
  var _useQuery = useQuery({
      queryKey: browseTopicsQueryKey(topicId),
      queryFn: fetchTopics,
      staleTime: 1000 * 60 * 60,
      // 1 hour
      enabled: enabled
    }),
    data = _useQuery.data,
    isError = _useQuery.isError,
    isLoading = _useQuery.isLoading;
  return {
    data: data,
    isLoading: isLoading,
    isError: isError
  };
}